import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "../authorization/service/slice";
import eventSlice from "src/store/events/eventSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import { rtkQueryErrorHandler } from "./middleware/rtkQueryErrorHandler";
import { appApi } from "../api/api";
import { chatApi } from "src/api/chatApi";
import userSlice from "./User/slice";
import toastSlice from "./toast/slice";
import broadcastSlice from "src/broadcasting/service/slice";
import chatSliceReducer from "./chat/chatSlice";
import otherUserSlice from "./otherUser/otherUserSlice";


export const store = configureStore({
  reducer: {
    login: AuthSlice,
    user: userSlice,
    otherUser: otherUserSlice,
    toast: toastSlice,
    event: eventSlice,
    broadcast: broadcastSlice,
    chat: chatSliceReducer,
    [appApi.reducerPath]: appApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().
    concat(appApi.middleware).
    concat(chatApi.middleware).
    concat(rtkQueryErrorHandler)
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export interface PageResponse<T> {
  items: T[];
  total: number;
  page: number;
  pages: number;
  size: number;
}